<template>
  <div class="company-map ml-4 mr-4">
    <div v-if="type === 'create'">
      <div class="row py-3 align-items-center">
        <div class="col company-h1">
          <button type="button"
                  class="btn btn-back"
                  @click="setCompanyStep('companies-info')"
          />
          Create Company
        </div>
        <div class="col text-right">
          <button type="button"
                  class="btn btn-primary ld-ext-right"
                  :class="loadingButton ? 'running' : ''"
                  :disabled="buttonDisabled"
          >
            Save
            <div class="ld ld-ball ld-flip" />
          </button>
        </div>
      </div>
      <companies-steps-menu type="create" />
    </div>
    <div v-if="type === 'edit'">
      <div class="row py-3 align-items-center company-header">
        <div class="col-4">
          <h2 class="company-h1 mr-3">
            <button type="button"
                    class="btn btn-back"
                    @click="$router.push('/companies')"
            />
            {{ company.name }}
          </h2>
          <template v-if="company.status">
            <span v-if="company.status.name === 'Active'"
                  :class="'btn-status btn-active'"
            >{{ company.status.name }}</span>
            <span v-if="company.status.name === 'Inactive'"
                  :class="'btn-status btn-closed'"
            >{{ company.status.name }}</span>
            <span v-if="company.status.name === 'Setup Incomplete'"
                  :class="'btn-status btn-ncover info-company'"
            >{{ company.status.name }}
              <div class="btn btn-link p-0 tippy-popup tippy-info" @mouseover="showTooltipPrefix = true"
                   @mouseout="showTooltipPrefix = false"
              >
                <i class="fa fa-info-circle" />
              </div>
              <div class="popover tippy-info-popover" v-if="showTooltipPrefix">
                Setup incomplete is present when the company doesn't have one or more of the following: move sizes, arrival windows, merchant account, rates and coverage.
              </div>
            </span>
          </template>
        </div>
        <div class="col-8 d-flex align-items-center justify-content-end">
          <companies-visibility-bar
            :company="company"
            @saved="$emit('saved')"
            v-if="$_can('companies.review.request')"
          />
          <button type="button"
                  class="btn btn-primary ld-ext-right ml-5"
                  :class="loadingButton ? 'running' : ''"
                  :disabled="buttonDisabled"
          >
            Save
            <div class="ld ld-ball ld-flip" />
          </button>
        </div>
      </div>
    </div>

    <div class="mb-3 w-100">
      <h5 class="companies-sub-page-title">Billing info</h5>
      <p class="description-text">You can enter your billing details on this page. This is how you will receiving earnings made from bookings on Mod24 website. You can opt to setup your bill.com or receive checks.</p>
      <div class="payout-wrapper">
        <div class="payout-status">
          <h5 class="payout-title">Your next payout date will be determined after approval.</h5>
          <button class="btn btn-not-have-billing mt-3" v-if="!company.company_billing">You don't have any billing details saved.</button>
        </div>
        <div class="payout-buttons">
          <button class="btn" @click="showBillingModal = true">{{ company.company_billing && company.company_billing.id ? 'Edit' : 'Add' }} Billing Details</button>
          <button class="btn" disabled>View Payments History</button>
        </div>
      </div>

      <div class="d-flex mt-3 align-items-center justify-content-between section-wrapper">
        <div class="tier">
          <h2 class="l-header-2">Tier level</h2>
          <div v-if="company.mod_tier" class="d-flex align-items-center justify-content-between">
            <h5 class="tier-title m-0">{{ company.mod_tier.name }}</h5>

            <ul class="tier-properties ml-5">
              <li v-for="tierOption in company.mod_tier.mod_tier_options" :key="tierOption.id">{{ tierOption.name }}</li>
            </ul>
          </div>
          <div v-else class="no-tier p-3">
            Company doesn't have tier.
          </div>
        </div>

        <div class="tier-buttons">
          <span @click="setCompanyStep('companies-tier')">
            <router-link :to="`/companies/edit/${$route.params.id}?tab=companies-tier`" class="btn">Change Tier level</router-link>
          </span>
        </div>
      </div>

      <div class="d-flex mt-3  flex-column section-wrapper">
        <h2 class="l-header-2">Your company details</h2>
        <p class="mt-1">
          Company details for <b>{{ dateFrom }}</b> - <b>{{ dateTo }}</b>
        </p>
        <div>
          <a href="javascript:void(0)" @click="togglePreviousOrCurrentMonth">Show <template v-if="currentMonth">previous</template><template v-else>current</template> month</a>
        </div>

        <table v-if="companyEarningInfo" class="company-info-table mt-3">
          <tbody>
            <tr>
              <td>Website bookings</td>
              <td class="amount">{{ companyEarningInfo.booked_jobs }}</td>
            </tr>
            <tr>
              <td>Completed jobs</td>
              <td class="amount">{{ companyEarningInfo.completed_jobs }}</td>
            </tr>
            <tr>
              <td>Total earned</td>
              <td class="amount">${{ companyEarningInfo.total_earned }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showBillingModal" @click.self="showBillingModal = false">
        <div class="filters-side-modal flex flex-column justify-content-start">
          <template v-if="showSearchComponent">
            <vendor-search-results :search-results="searchResults" v-if="showSearchComponent" @back="hideSearchComponent" @cancel="resetModal" @saved="saved" />
          </template>
          <template v-else>
            <div @click="showBillingModal = !showBillingModal" class="pointer">
              <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Billing Details</h1>
            </div>
            <div>
              <p>
                We are using Bill.com for transfer funds from one organization to another.
              </p>
              <p>
                Use the search to find your account and we'll send you and invite to connect with Mod24. Or select the option to receive payouts via check.
              </p>
            </div>
            <div class="l-bg-white">
              <span class="add-billing-select-text">How would you like to receive payments?</span>
              <div class="add-billing-options mt-3 mx-3">
                <div class="billing-option" @click="typeSelected = 'check'" :class="{'billing-option-selected': typeSelected === 'check'}">
                  <div class="billing-details d-flex align-items-center">
                    <span class="mod-icon-billing-check mr-1" />
                    <div class="billing-option-info">
                      <span class="billing-option-title">Check payout</span>
                      <p class="billing-option-description">Select to receive payments as checks</p>
                    </div>
                  </div>
                  <span v-if="typeSelected === 'check'" class="mod-icon-billing-option-checked" />
                </div>
              </div>
              <div class="add-billing-options mt-3 mx-3">
                <div class="billing-option" @click="typeSelected = 'bill.com'" :class="{'billing-option-selected': typeSelected === 'bill.com'}">
                  <div class="billing-details d-flex align-items-center">
                    <span class="mod-icon-bill mr-1" />
                    <div class="billing-option-info">
                      <span class="billing-option-title">Bill.com</span>
                      <p class="billing-option-description">Find your account by using network search or create account</p>
                    </div>
                  </div>
                  <span v-if="typeSelected === 'bill.com'" class="mod-icon-billing-option-checked" />
                </div>
              </div>

              <div class="mt-5">
                <check :company="company" v-if="typeSelected === 'check'" @cancel="showBillingModal = false" @saved="saved" />
                <vendor-search v-if="typeSelected === 'bill.com'" @cancel="showBillingModal = false" @searchCompleted="showSearchResults" />
              </div>
            </div>
          </template>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import axios from 'axios';
import toastr from 'toastr';
import moment from 'moment';
import Check from './Check';
import CompaniesStepsMenu from '../CompaniesStepsMenu';
import CompaniesVisibilityBar from '../CompaniesVisibilityBar';
import VendorSearch from './VendorSearch';
import VendorSearchResults from './VendorSearchResults';

export default {
  name: 'CompaniesBillingInfo',
  components: {
    Check,
    CompaniesStepsMenu,
    CompaniesVisibilityBar,
    VendorSearch,
    VendorSearchResults,
  },
  props: {
    type: {
      type: String,
      default: 'edit',
    },
    company: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    assignmentTypes: [],
    buttonDisabled: false,
    companyEarningInfo: null,
    config: {
      dateFormat: 'm/d/Y',
      wrap: true,
      disableMobile: true,
    },
    currentMonth: true,
    dateFrom: moment()
      .startOf('month')
      .format('MM/DD/YYYY'),
    dateTo: moment()
      .endOf('month')
      .format('MM/DD/YYYY'),
    loadingButton: false,
    searchResults: [],
    showBillingModal: false,
    showTooltipPrefix: false,
    showSearchComponent: false,
    typeSelected: null,
  }),
  watch: {
    company() {
      this.initType();
    },
  },
  mounted() {
    this.initType();
    this.fetchcompanyEarningInfo();
  },
  methods: {
    ...mapMutations(['setCompanyStep']),
    fetchcompanyEarningInfo() {
      if (this.company.company_billing && this.company.company_billing.id) {
        axios
          .get(
            `/companies/${this.$route.params.id}/billing-info?date_from=${
              this.dateFrom ? this.dateFrom : ''
            }&date_to=${this.dateTo ? this.dateTo : ''}`,
          )
          .then(response => {
            this.companyEarningInfo = response.data.data;
          })
          .catch(() => {
            toastr.error('Server error!');
          });
      }
    },
    hideSearchComponent() {
      this.showSearchComponent = false;
      this.typeSelected = 'bill.com';
    },
    initType() {
      if (this.company.company_billing) {
        if (parseInt(this.company.company_billing.pay_by, 10) === 0) {
          this.typeSelected = 'check';
        } else {
          this.typeSelected = 'bill.com';
        }
      }
    },
    resetModal() {
      this.saved();
      this.typeSelected = null;
      this.showSearchComponent = false;
    },
    saved() {
      this.$emit('saved');
      this.showBillingModal = false;
    },
    showSearchResults(searchResults) {
      this.searchResults = searchResults;
      this.typeSelected = null;
      this.showSearchComponent = true;
    },
    togglePreviousOrCurrentMonth() {
      if (this.currentMonth) {
        const previousMonth = moment().month();
        this.dateFrom = moment(previousMonth, 'M')
          .startOf('month')
          .format('MM/DD/YYYY');
        this.dateTo = moment(previousMonth, 'M')
          .endOf('month')
          .format('MM/DD/YYYY');
        this.currentMonth = false;
      } else {
        this.dateFrom = moment()
          .startOf('month')
          .format('MM/DD/YYYY');
        this.dateTo = moment()
          .endOf('month')
          .format('MM/DD/YYYY');
        this.currentMonth = true;
      }
      this.fetchcompanyEarningInfo();
    },
  },
};
</script>

<style scoped lang="scss">
.date-range-input {
  background-color: #e1e1e1;
  padding: 3px;
  cursor: pointer;
}

.description-text {
  margin-top: 15px;
  margin-left: 15px;
  width: 50%;
  font-size: 0.8rem;
}

.payout-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  padding-bottom: 15px;
  border-bottom: 1px solid #d1d5d9;

  .payout-title {
    font-weight: 500;
  }
}

.payout-buttons {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 20%;

  .btn {
    color: #0f47e2;
    font-size: 0.9rem;
  }
}

.tier-buttons {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 20%;
}

.section-wrapper {
  width: 80%;
  padding-bottom: 15px;
  border-bottom: 1px solid #d1d5d9;

  a {
    color: #0f47e2;
    font-size: 0.9rem;
  }
}

.tier-title {
  font-weight: 500;
}

.tier-properties {
  font-size: 0.7rem;
}

.no-tier {
  background-color: #ffc3c3;
}

.company-info-table {
  max-width: 40%;

  td {
    color: #000;
  }

  .amount {
    color: #0f47e2 !important;
  }
}

.btn-not-have-billing {
  color: #f37382;
  border: 1px solid #f37382;
}

.add-billing-select-text {
  text-transform: uppercase;
  font-weight: 500;
  font-size: 0.9rem;
}

.billing-option-selected {
  border: 1px solid #0f47e2 !important;
}

.billing-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 15px 5px 15px;
  border-radius: 5px;
  border: 1px solid #ffffff;
  cursor: pointer;

  .billing-option-info {
    display: flex;
    flex-direction: column;
    flex: 1;

    .billing-option-title {
      font-weight: 500;
    }

    .billing-option-description {
      font-size: 0.8rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/companies/mod24settings/CompaniesBillingInfo.vue